var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-view",
    style: ({
      minHeight: !_vm.getMobile && _vm.getViewport ? ((_vm.getViewport.height - 230 - 182) + "px") : '0'
    })
  }, _vm._l((_vm.articleLines), function(line) {
    return (line.length > 0) ? _c('div', {
      staticClass: "article-view__line"
    }, _vm._l((line), function(item, index) {
      return _c('capsule-article', {
        key: "capsule",
        attrs: {
          "content-data": item,
          "propId": index
        }
      })
    })) : _vm._e()
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a139b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/common/article/ArticleView.vue
// module id = Y1US
// module chunks = 1